import { format as dateFormat, addMinutes } from 'date-fns';

const formatDate = (value?: string, format = 'MM/dd/yyy'): string => {
  if (!value) return '';
  const date = new Date(value);
  return dateFormat(addMinutes(date, date.getTimezoneOffset()), format);
};

export default formatDate;
